"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateCreate = void 0;
const FetchHelper_1 = __importDefault(require("../helpers/FetchHelper"));
async function estimateCreate(trip, waveApiUrl) {
    const response = await FetchHelper_1.default.json(`${waveApiUrl}/estimates`, { trip }, { method: 'POST' });
    const json = (await response.json());
    return json;
}
exports.estimateCreate = estimateCreate;
